import axios from "axios";

// Configure axios instance with the base URL and default headers
const instance = axios.create({
  // baseURL: "https://owlapis.owltecheg.com/api",
  // baseURL: "http://localhost:3000/api",
  baseURL: "https://owls.owltecheg.net/api",
});

const AUTH_PATHS_SKIP_401_LOGOUT = [
  "users/login",
  "users/login/verify2fa",
];

function getRequestUrl(config) {
  if (!config) return "";
  const url = config.url || "";
  const base = config.baseURL || "";
  try {
    return new URL(url, base || window.location.origin).pathname;
  } catch {
    return url;
  }
}

function shouldSkipLogoutOn401(config) {
  const path = getRequestUrl(config).toLowerCase();
  return AUTH_PATHS_SKIP_401_LOGOUT.some((p) => path.includes(p));
}

function isStaleAuthRequest(config) {
  const currentToken = localStorage.getItem("token");
  const authHeader =
    config?.headers?.Authorization || config?.headers?.authorization || "";
  const requestToken = String(authHeader).replace(/^Bearer\s+/i, "").trim();

  // Request had no token, or current session token changed since the request was sent
  if (!requestToken) return false;
  if (!currentToken) return false;
  return requestToken !== currentToken;
}

// Add a request interceptor to include the token in the headers
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const config = error.config;

      // Don't wipe a fresh session because of login/2FA 401s or stale in-flight requests
      if (!shouldSkipLogoutOn401(config) && !isStaleAuthRequest(config)) {
        localStorage.removeItem("token");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
